import { render, staticRenderFns } from "./TemplateDialog.vue?vue&type=template&id=ed2c52ce"
import script from "./TemplateDialog.vue?vue&type=script&lang=js"
export * from "./TemplateDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports